import { faCircleInfo, faRectangleList } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Alert,
  Card,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Icon } from "@progress/kendo-react-common";
import axios from "axios";
import { useFormik } from "formik";
import moment from "moment";
import { useAuth } from "oidc-react";
import React, { Fragment, useCallback, useEffect, useState, useMemo } from "react";
import { CardBody, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import { getUserRole, isOlderThen, ShowError, ShowSucess, sortDisbled } from "../../_helper/helper";

import { useLocation, useParams } from "react-router-dom";
import { loadingPanel, ConcatenedColumns } from "../../CommonComponents/CommonFunction";
import ActiveHealthAndDeductionPlan from "./Components/ActiveHealthAndDeductionPlan";
import { companyArrayDental as companyArray } from "../../_helper/helper";
import ConfirmationModel from "./Components/ConfirmationModel";
import DependentSelection from "./Components/DependentSelection";
import DocumentViewer from "../../Components/HealthOpenEnrollment/Components/DocumentView";
import { currentProcessStatus, getAuditTrail } from "../../CommonFunction/ProcessStatus";
import StepperComponent from "../Stepper/StepperComponent";
import ApprovalModal from "../ApprovalModal/ApprovalModal";
import StatusCard from "../StatusCard/StatusCard";
import dayjs from "dayjs";
import HistoryColumns from "./HistoryColumns";
import DifferencesModal from "./DifferencesModal";
import HistoryDataTable from "../../CommonComponents/AuditLog/HistoryDataTable";
import { Btn } from "../../AbstractElements";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    ".&.MuiExpansionPanelSummary-content": {
      padding: 0,
    },
    ".css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "32px",
    },
    "& .MuiPaper-root": {
      background: "none",
      display: "block",
    },
    margin: "0 !important",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "70%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
}));

const DentalEnrollmentMain = () => {
  const classes = useStyles();
  const { employeeId } = useParams()
  const { state } = useLocation()
  // const {Dental_CurrentProcessid : dentalCurrentProcessid} = state

  const initialDependent = {
    lastName: "",
    firstName: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    email: "",
    middleName: "",
  };

  const location = useLocation();
  const columns = location.state;
  const [dependentInformation, setDependentInformation] = useState([]);
  const [dependentforApproval, setDependentforApproval] = useState([])
  const [auditTrailData, setAuditTrailData] = useState([]);
  const [deletedDependent, setdeletedDependent] = useState([]);
  const [expanded, setExpanded] = React.useState({
    empDetail: true,
    healthandDeduction: true,
    dependent: true,
  });
  const [historyData, setHistoryData] = useState([]);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [differenceData, setDifferenceData] = useState([]);
  const [openDiffModal, setOpenDiffModal] = useState(false);
  const [sortData, setSortData] = useState([
    { field: "changeDateTime", dir: "desc" },
  ]);
  const [sortedColumns, setSortedColumns] = useState([]);
  useEffect(() => {
    ConcatenedColumns(columns, HistoryColumns, setSortedColumns, userData);
  }, [columns, sortData]);

  const handleChangeExpanded = (panel) => (event, isExpanded) => {
    setExpanded((prevState) => ({
      ...prevState,
      [panel]: isExpanded,
    }));
  };
  const { userData } = useAuth();
  const [isDocumentViewer, setIsDocumentViewer] = useState(false);
  const [selfData, setSelfData] = useState({});


  const [show, setShow] = useState(false);
  const [loding, setLoading] = useState(false);
  const [isConfirmationModel, setIsConfirmationModel] = useState(false);
  const [defaultOpen, setDefaultOpen] = useState(true);
  const [processStatus, setProcessStatus] = useState([])
  // const [auditTrailData, setAuditTrailData] = useState(null);
  const [approvalHandleModal, setApprovalHandleModal] = useState(false)


  const [schema, setPerformanceSchema] = useState({
    employee_no: Yup.string().required("Employee No. is required"),
    DOB: Yup.string().required("DOB is required"),
    last_name: Yup.string().required("Last Name is required"),
    ssn: Yup.string()
      .required("SSN is required")
      .test(
        "len",
        "Must be exactly 4 characters",
        (val) => val && val.toString().length === 4
      ),
  });

  const initialItem = {
    employee_no: "",
    DOB: "",
    last_name: "",
    ssn: "",
    dentalVendor: "",
    dentalPlan: "",
    UID: "",
    Employeetype: "",
    dentalDeductionClass: "",
    subscriberId: "",
    id: "",
    amount: "",
    email: "",
    mailingAddress: "",
    olddentalPlan: "",
    olddentalVendor: "",
    dentalCurrentProcessid: "",
    dentalHrcontrol: ""
  };

  const OpenHistoryComponent = () => {
    // This function will now ONLY start the data fetch process.
    if (values.UID) {
      getData(values);
    }
  };
  const onSubmit = (e) => {
    // API Calling
    setLoading(true);
    // searchEmployeeAPI(values?.DOB, values?.ssn, values?.last_name, values?.employee_no);
    getBenefitsData(employeeId)
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    validateForm,
    setValues,
  } = useFormik({
    initialValues: initialItem,
    validationSchema: Yup.object().shape(schema),
    onSubmit,
  });


  useEffect(() => {
    if (employeeId) {

      setLoading(true)
      getBenefitsData(employeeId)
      // searchEmployeeAPI(userData?.profile?.DOB, userData?.profile?.SSN, userData?.profile?.LastName, userData?.profile?.EmployeeID)
      // setValues({
      //   ...values,
      //   DOB: userData?.profile?.DOB,
      //   employee_no: userData?.profile?.EmployeeID,
      //   last_name: userData?.profile?.LastName,
      //   ssn: userData?.profile?.SSN,
      // })
    }
  }, [employeeId])

  const handleUpdatePlan = () => {
    if (values?.UID && values?.dentalPlan && values?.dentalVendor) {
      setLoading(true);
      const payload = {
        uid: values?.UID,
        dentalVendor: values?.dentalVendor,
        dentalPlan: values?.dentalPlan,
        dentalDeductionClass: values?.dentalDeductionClass,
      };
      axios
        .put(
          `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/update`,
          [{ ...payload }],
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          ShowSucess("Successfully Updated.");
        })
        .catch((error) => {
          setLoading(false);
          ShowError("Internal Server Error !");
        });
    } else {
      ShowError("Please select any health plan");
    }
  };

  const getDependentList = async (employeeId) => {
    try {
      const getDependent = await axios.get(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/GetBySubscriberId?SubscriberId=${employeeId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      );
      let firstObj = getDependent.data.filter((i) => i.employeeId == i.subscriberId)

      setValues({ ...values, dentalDeductionClass: firstObj[0]?.dentalDeductionClass })
      setDependentInformation(
        getDependent.data.length > 1
          ? getDependent.data.filter((i) => i.employeeId !== i.subscriberId)?.length ? getDependent.data.filter((i) => i.employeeId !== i.subscriberId) : [
            {
              ...initialDependent,
              subscriberId: employeeId,
              email: values?.email,
              mailingAddress: values?.mailingAddress,
              lastName: values?.last_name,
            },
          ]
          : [
            {
              ...initialDependent,
              subscriberId: employeeId,
              email: values?.email,
              mailingAddress: values?.mailingAddress,
              lastName: values?.last_name,
            },
          ]
      );
    } catch (error) {
      setDependentInformation([
        {
          ...initialDependent,
          subscriberId: employeeId,
          email: values?.email,
          mailingAddress: values?.mailingAddress,
          lastName: values?.last_name
        },
      ])
    }
    setdeletedDependent([]);
  };

  const getProcessStatus = async () => {
    const response = await currentProcessStatus(132)
    setProcessStatus(response)
    console.log(response, 'currentProcessStatus')
  }

  useEffect(() => {
    getProcessStatus()
  }, [])

  const handleSortChange = (sort) => {
    setSortData(sort);
  };


  const handleDependentUpdate = async (newDependentInfo) => {

    if (newDependentInfo && Object.keys(newDependentInfo).length) {
      dependentInformation.push(newDependentInfo)
    }

    if (
      dependentInformation.some(
        (i) =>
          !i.firstName ||
          !i.lastName ||
          !i.middleName ||
          (!i["role"].includes('Coverage') && i.DentalSubscriberID && !i.relation) ||
          !i.gender ||
          (i?.relation === 'Child' && isOlderThen(i.dob))

        // ||
        // !i.dob
      )
    ) {
      ShowError("Please Check Dependent Information");
      return false;
    }


    setLoading(true);
    let currnetClassValue = ""
    // let currnetClassValue = await setClassValues(dependentInformation)
    if (values?.dentalPlan && values?.dentalVendor) {
      currnetClassValue = await setClassValues(dependentInformation)
    }

    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/CreateOrUpdateDeteteBenefits`,
        // {
        //   createnupdate: [
        //     ...dependentInformation?.map((i) => {
        //       i?.uid && delete i.ssn
        //       return { ...i, dependentFor: "Dental", dentalDeductionClass: i.DentalSubscriberID ? currnetClassValue : "", dentalSubscriberId: i.DentalSubscriberID, dentalType: i.relation, employeeId: !i?.uuid ? ' ' : i.employeeId }
        //     }),
        //     ...[
        //       {
        //         uid: values?.UID,
        //         dentalVendor: values?.dentalVendor,
        //         dentalPlan: values?.dentalPlan,
        //         dentalDeductionClass: currnetClassValue,
        //         subscriberId: values?.subscriberId,
        //         id: values?.id,
        //         dependentFor: "Dental",
        //         approvedBy: userData?.profile?.EmployeeID
        //       },
        //     ],
        //   ],
        //   deletedList: deletedDependent,
        // },
        {
          createnupdate: [
            ...dependentInformation?.map((i) => {
              i?.uid && delete i.ssn
              return {
                ...i, dependentFor: "Dental", dentalDeductionClass: i.DentalSubscriberID ? currnetClassValue : "",
                DentalSubscriberID: values?.dentalPlan && values?.dentalVendor ? i.DentalSubscriberID : "",
                employeeId: !i?.uuid ? ' ' : i.employeeId,
                benefitId: !i?.uuid ? " " : i.employeeId,
                dentalType: i.relation,
                // "healthCurrentProcessid": processStatus?.[1]?.ID,
                // "lifeCurrentProcessid": 0,
                "dentalCurrentProcessid": values?.dentalCurrentProcessid,
                "hrControlTypes": ["Dental"],
                dentalHrcontrol: i.DentalSubscriberID ? selfData?.Dental_Hrcontrol : "",
              }
            }),
            ...[
              {
                uid: values?.UID,
                dentalVendor: values?.dentalVendor,
                dentalPlan: values?.dentalPlan,
                dentalDeductionClass: currnetClassValue,
                subscriberId: values?.subscriberId,
                id: values?.id,
                dependentFor: "Dental",
                "hrControlTypes": ["Dental"],
                "dentalCurrentProcessid": values?.dentalCurrentProcessid,
                approvedBy: userData?.profile?.EmployeeID,
                ...(!values?.dentalPlan && !values?.dentalVendor && { DentalSubscriberID: "" }),
                dentalHrcontrol: selfData?.Dental_Hrcontrol
              },
            ],
          ],
          deletedList: deletedDependent,
          transactionStatus: "Update",
          currentProcessid: values?.dentalCurrentProcessid || "0",
          hrControl: selfData?.Dental_Hrcontrol,
          remark: "",
          type: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      )
      .then(async (response) => {
        await getBenefitsData(values?.employee_no);
        ShowSucess("Successfully Updated.");
        fetchAuditTrail()
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const fetchAuditTrail = useCallback(async () => {
    if (!values?.dentalHrcontrol) {
      return; // Return early if healthHrcontrol is not defined
    }

    try {
      const getAuditTrailData = await getAuditTrail(values.dentalHrcontrol);
      if (getAuditTrailData != undefined) {
        setAuditTrailData(getAuditTrailData);
      }
    } catch (error) {
      console.error("Error fetching audit trail data:", error);
      // Optionally, you can handle the error state, e.g., set an error message state
    }
  }, [values?.dentalHrcontrol]);

  useEffect(() => {
    fetchAuditTrail();
  }, [fetchAuditTrail]);

  const handleDependentDelete = (uid) => {
    setdeletedDependent([...deletedDependent, uid]);
  };

  const getData = (values) => {
    setLoading(true);
    const payload = {
      tableName: "vw_auditBenefits_MASTER",
      // tableName: "Benefits_Death_Intake",
      SearchParams: "",
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "ID DESC",
      sortBy: "",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: `uid = '${values?.UID}'`,
    };
    axios
      .post(`${process.env.REACT_APP_API_DOTNET_URL}/BenefitAdvanceSearch/Benefits-global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        setHistoryData(response?.data?.results);
        setIsHistoryModalOpen(true);
        setLoading(false);
        console.log(response, 'intackdata')
      })
      .catch((error) => {
        setLoading(false);
      });
  }



  const renderGroupCheckbox = (
    size = "large",
    stateName,
    value,
    other = null
  ) => {
    let defaultChk = (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setFieldValue(stateName, values[stateName] == value ? '' : value);
        }}
      />
    );

    if (other && other.matchkey && other.matchkey1) {

      defaultChk = (
        <Checkbox
          size={size}
          checked={
            values[stateName] == value &&
            values[other.matchkey] == other.matchvalue &&
            values.dentalPlan
          }
          disabled={other?.disabled ? other?.disabled : false}
          onChange={(e) => {
            if (
              stateName == "dentalDeductionClass" &&
              other?.changeTarget1 &&
              other?.changeTarget1 == "dentalVendor" &&
              other?.changeTarget2 == "dentalPlan"
            ) {
              setFieldValue(other?.changeTarget1, other?.changeTargetValue1);
              setFieldValue(other?.changeTarget2, other?.changeTargetValue2);
            }

            setFieldValue(stateName, values[stateName] == value ? '' : value);
          }}
        />
      );
    } else if (other && other.matchkey) {

      defaultChk = (
        <Checkbox
          size={size}
          checked={
            values[stateName] == value &&
            values[other.matchkey] == other.matchvalue
          }
          disabled={other?.disabled ? other?.disabled : false}
          onChange={(e) => {
            if (
              stateName == "dentalDeductionClass" &&
              other?.changeTarget1 &&
              other?.changeTarget1 == "dentalVendor" &&
              other?.changeTarget2 == "dentalPlan"
            ) {
              setFieldValue(other?.changeTarget1, other?.changeTargetValue1);
              setFieldValue(other?.changeTarget2, other?.changeTargetValue2);
            }
            if (stateName == "dentalPlan" && other.matchkey) {

              if (e.target.checked) {
                setFieldValue(
                  "dentalDeductionClass",
                  values.dentalDeductionClass
                );
                setFieldValue(other?.matchkey, other?.matchvalue)
              } else {
                if (values?.olddentalPlan && values?.olddentalVendor) {
                  setIsConfirmationModel(true)
                } else {
                  handleUnClick()
                }
                // setIsConfirmationModel(true)

                // setFieldValue(
                //   "healthDeductionClass",
                //   ""
                // );
                // setFieldValue(other?.matchkey, "")
              }
            }
            if (e.target.checked) {
              setFieldValue(stateName, value);
            }
            // else {
            //   setFieldValue(stateName, "");
            // }

            //   setFieldValue(
            //     "dentalDeductionClass",
            //     values.dentalDeductionClass
            //   );
            // }

            // setFieldValue(stateName, values[stateName] == value ? '' : value);
          }}
        />
      );
    } else {

      defaultChk = (
        <Checkbox
          size={size}
          checked={values[stateName] == value && !values.dentalPlan}
          onChange={(e) => {
            setFieldValue(stateName, values[stateName] == value ? '' : value);
          }}
        />
      );
    }

    return defaultChk;
  };


  function renderTextInput(stateName, label, others = {}) {
    let other = {
      disabled: false,
      maxLength: "",
      multiline: false,
      required: false,
      shrink: true,
      ...others,
    };
    let { disabled, maxLength, multiline, required, shrink } = other;
    return (
      <TextField
        fullWidth
        size="small"
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: "100%",
          },
          readOnly: disabled,
        }}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={values[stateName]}
        InputLabelProps={{ shrink: shrink ? shrink : false }}
        shrink={shrink ? shrink : false}
        onChange={(e) => {
          if (!disabled) {
            setShow(false);
            handleChange(e);
          }
        }}
        onBlur={handleBlur}
        error={!disabled && touched[stateName] && errors[stateName]}
        helperText={
          !required && !disabled && touched[stateName] && errors[stateName]
        }
        disabled={disabled}
        required={required}
      />
    );
  }

  function renderDateInput(
    stateName,
    label,
    disabled = false,
    minDate = null
    // maxDate
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputVariant={"outlined"}
          margin="dense"
          format="MM/dd/yyyy"
          label={label}
          minDate={minDate}
          // maxDate={maxDate}
          value={values[stateName]}
          KeyboardButtonProps={{ "aria-label": label }}
          disabled={disabled}
          onChange={(value) => {
            const formatDate = value?.$d;
            const date = formatDate
              ? moment(formatDate).format("YYYY-MM-DD hh:mm:ss")
              : null;
            setShow(false);
            setFieldValue(stateName, date);
          }}
          onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
              {...params}
              error={!disabled && errors[stateName]}
              helperText={!disabled && errors[stateName]}
            />
          )}
        />
      </LocalizationProvider>
    );
  }


  function renderDropDown(stateName, label, value, disabled) {
    return (
      <div>
        <TextField
          margin="dense"
          className="flex w-full  mt-2"
          variant="outlined"
          select
          SelectProps={{ native: true }}
          style={{ width: "100%" }}
          size="small"
          disabled={disabled}
          inputProps={{
            style: {
              fontSize: "14px",
              color: "b:12px",
            },
          }}
          label={label}
          name={stateName}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            handleChange(e);
          }}
          error={!disabled && errors[stateName]}
          helperText={!disabled && errors[stateName]}
          value={values[stateName]}
        >
          {/* <option value={""} disabled> */}
          {/* value={values[stateName]}> */}
          <option value={""} disabled>
            Select {label}
          </option>

          {value.length &&
            value.map((option) => (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            ))}
        </TextField>
      </div>
    );
  }

  const renderCheckbox = (size = "large", stateName, value) => {
    return (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setFieldValue(stateName, value);
        }}
      />
    );
  };

  console.log("Dadasddasd", values);
  const setAmount = (currentClass) => {
    let getAmount = companyArray
      .find((item) => item.vendor_name == values?.dentalVendor)
      ?.vendor_items.find((item) => item.vendor_code == values?.dentalPlan)
      ?.classInfo.find(
        (ite) => ite.value == currentClass
      )?.amount;
    setFieldValue("amount", getAmount);
  }

  const setClassValues = async (dependentArray1) => {
    let dependentArray = dependentArray1?.filter((i) => !i.role.includes("Coverage") && i.DentalSubscriberID)
    const uniqueValues = [
      ...new Set(dependentArray.map((obj) => obj.relation)),
    ];

    if (uniqueValues.every((i) => i == "")) {
      if (values?.dentalDeductionClass != "I") {
        setAmount("I")
        ShowSucess(`Class changed ${values?.dentalDeductionClass} to I `);
        setFieldValue("dentalDeductionClass", "I");
      }
      return "I";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.every((i) => ["Spouse", "Domesticpartner"].includes(i))
        : uniqueValues.every(
          (i) => ["Spouse", "Domesticpartner"].includes(i) || i == ""
        )
    ) {
      if (values?.dentalDeductionClass != "II") {
        setAmount("II")
        ShowSucess(`Class changed ${values?.dentalDeductionClass} to II `);
        setFieldValue("dentalDeductionClass", "II");
      }
      return "II";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.every((i) => ["Child"].includes(i))
        : uniqueValues.every((i) => i == "Child" || i == "")
    ) {
      if (values?.dentalDeductionClass != "III") {
        setAmount("III")
        ShowSucess(`Class changed ${values?.dentalDeductionClass} to III`);
        setFieldValue("dentalDeductionClass", "III");
      }
      return "III";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.some((i) => ["Spouse", "Domesticpartner"].includes(i)) &&
        uniqueValues.some((i) => ["Child"].includes(i))
        : uniqueValues.some(
          (i) => ["Spouse", "Domesticpartner"].includes(i) || i == ""
        ) && uniqueValues.some((i) => ["Child"].includes(i))
    ) {
      if (values?.dentalDeductionClass != "IV") {
        setAmount("IV")
        ShowSucess(`Class changed ${values?.dentalDeductionClass} to IV `);
        setFieldValue("dentalDeductionClass", "IV");
      }
      return "IV";
    }
  };



  const getDateDifference = () => {

    const currentYear = moment().year();
    const defaultDate = moment(`09-30`, 'MM-DD').year(currentYear);
    const currentDate = moment().year(currentYear);

    // Adjust the year for selectedDate if it is before constDate
    if (defaultDate.isBefore(currentDate)) {
      defaultDate.add(1, 'year');
    }

    // Calculate the difference in days
    const diffDays = defaultDate.diff(currentDate, 'days');

    return { diffDays, defaultDate, currentDate };
  }

  const getBenefitsData = async () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const payload = {
      tableName: "sp_BenefitsDependent_v2",
      SearchParams: `[{"columnName":"EmpId","operator":"=","value":'${employeeId}',"dataType":"VARCHAR"}]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "",
      sortBy: "Role desc",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: "",
    };
    axios
      .post(`${newBaseURL}/BenefitAdvanceSearch/Benefits-global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        let finalData = response?.data?.results;
        let resData = finalData.find((i) => i.Dependants == 'Self')
        finalData = sortDisbled(finalData)

        finalData = finalData?.map((i) => {
          return { ...i, firstName: i.FirstName, middleName: i.MiddleName, lastName: i.LastName, role: i.Role ? i.Role : '', relation: i.Relation, gender: i.Gender, dob: i.DOB, mailingAddress: i.MailingAddress, email: i.Email, dentalDeductionClass: i.DentalDeductionClass }
        })
        let searchData = {
          UID: resData?.UID,
          employee_no: resData?.EmployeeID,
          subscriberId: resData?.SubscriberID,
          Employeetype: resData?.EmployeeType,
          dentalVendor: resData?.DentalVendor,
          dentalPlan: resData?.DentalPlan,
          dentalDeductionClass: resData?.DentalDeductionClass,
          email: resData?.Email,
          lastName: resData?.LastName,
          mailingAddress: resData?.MailingAddress,
          olddentalPlan: resData?.DentalPlan,
          olddentalVendor: resData?.DentalVendor,
          dentalCurrentProcessid: resData?.Dental_CurrentProcessid,
          dentalHrcontrol: resData?.Dental_Hrcontrol
        };
        setValues((state) => { return { ...state, ...searchData } });
        setSelfData(resData)

        // setValues({...values,dentalDeductionClass:firstObj[0]?.DentalDeductionClass})
        setDependentInformation(
          finalData.length > 1
            ? finalData.filter((i) => i.Dependants == "Dental Dependants")?.length ? finalData.filter((i) => i.Dependants == "Dental Dependants") : [] : []
        );
        setDependentforApproval(
          finalData.length > 1
            ? finalData.filter((i) => i.Dependants == "Dental Dependants")?.length ? finalData.filter((i) => i.Dependants == "Dental Dependants") : [] : []
        );
        // setDependentInformation(
        //   finalData.length > 1
        //     ? finalData.filter((i) => i.EmployeeID !== i.SubscriberID && i.Dependants == "Dental Dependants")?.length ? finalData.filter((i) => i.EmployeeID !== i.SubscriberID && i.Dependants == "Dental Dependants") : [
        //       {
        //         ...initialDependent,
        //         subscriberId: employeeId,
        //         email: values?.email,
        //         mailingAddress: values?.mailingAddress,
        //         lastName: values?.last_name,
        //       },
        //     ]
        //     : [
        //       {
        //         ...initialDependent,
        //         subscriberId: employeeId,
        //         email: values?.email,
        //         mailingAddress: values?.mailingAddress,
        //         lastName: values?.last_name,
        //       },
        //     ]
        // );
      })
      .catch((error) => {

      }).finally(() => {
        setLoading(false)
      })
  }

  // const fetchAuditTrail = async () => {
  //   const getAuditTrailData = await getAuditTrail(values?.dentalHrcontrol);
  //   setAuditTrailData(getAuditTrailData);
  // };

  // useEffect(() => {
  //   if(values?.dentalHrcontrol){
  //   fetchAuditTrail();
  //   }
  // }, [values?.dentalHrcontrol]);

  const handleOpen = () => {
    setIsDocumentViewer(true);
  };

  const handleUnClick = () => {
    setValues({ ...values, dentalPlan: "", dentalVendor: "", dentalDeductionClass: "" })
  }

  const approvalHandler = useCallback(() => {
    setApprovalHandleModal(true)
  }, [])

  const handleClose = () => {
    setApprovalHandleModal(false)
  }

  const handleApprovalSubmit = (approvalData) => {
    // "healthCurrentProcessid": processStatus?.[1]?.ID,
    //             // "lifeCurrentProcessid": 0,
    //             // "dentalCurrentProcessid": 0,
    //             "hrControlTypes": ["Health"],
    const { option, remarks } = approvalData
    let processId = processStatus?.[2]?.ID
    if (option == "Return") {
      processId = processStatus?.[0]?.ID
    }
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/CreateOrUpdateDeteteBenefits`,
        {
          createnupdate: [
            ...dependentforApproval?.map((i) => {
              i?.uid && delete i.ssn;
              return {
                ...i,
                dependentFor: "Dental",
                dentalDeductionClass: i.DentalDeductionClass,
                dentalSubscriberID: i.DentalSubscriberID,
                employeeId: !i?.uuid ? " " : i.employeeId,
                benefitId: !i?.uuid ? " " : i.employeeId,
                dentalType: i.relation,
                dentalCurrentProcessid: processId,
                // "lifeCurrentProcessid": 0,
                // "dentalCurrentProcessid": 0,
                hrControlTypes: ["Dental"],
                dentalHrcontrol: i.DentalSubscriberID ? selfData?.Dental_Hrcontrol : "",
              };
            }),
            ...[
              {
                uid: values?.UID,
                dentalVendor: values?.dentalVendor,
                dentalPlan: values?.dentalPlan,
                dentalDeductionClass: values?.dentalDeductionClass,
                subscriberId: values?.subscriberId,
                id: values?.id,
                dependentFor: "Dental",
                approvedBy: userData?.profile?.EmployeeID,
                ...(!values?.dentalPlan &&
                  !values?.dentalVendor && { healthSubscriberID: "" }),
                hrControlTypes: ["Dental"],
                dentalCurrentProcessid: processId,
                dentalHrcontrol: selfData?.Dental_Hrcontrol,
              },
            ],
          ],
          deletedList: [],
          transactionStatus: option,
          currentProcessid: processId,
          hrControl: selfData?.Dental_Hrcontrol,
          remark: remarks,
          type: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      )
      .then(async (response) => {
        await getBenefitsData(values?.employee_no);
        getProcessStatus()
        fetchAuditTrail()
        ShowSucess("Successfully!");
        setLoading(false);
        handleClose();
      })
      .catch((error) => {
        setLoading(false);
      });

  };

  const actions = useMemo(() => {
    return [
      {
        title: "Show Details",
        action: (props) => {
          const findIndex =
            historyData &&
            historyData.findIndex((item) => {
              return item?.changeDateTime === props.dataItem.changeDateTime;
            });

          if (
            findIndex !== -1 &&
            findIndex + 1 < historyData.length
          ) {
            const filterData = [
              historyData[findIndex],
              historyData[findIndex + 1],
            ];

            setOpenDiffModal(true);
            setDifferenceData(filterData);
          }
        },
        icon: { iconName: "k-icon  k-i-eye" },
        className: "font-primary",
        style: { cursor: "pointer" },
      },
    ];
  });

  return (
    <Fragment>
      {loding && loadingPanel()}
      {isConfirmationModel &&
        <ConfirmationModel
          open={isConfirmationModel}
          setOpen={setIsConfirmationModel}
          // healthName={isDeSelectedHealth}
          handleSubmit={handleUnClick}
          modelTitle={"Are you sure to unsubscribe Dental Insurance"}
        />
      }
      {isDocumentViewer && (
        <DocumentViewer
          open={isDocumentViewer}
          setOpen={setIsDocumentViewer}
          fullWidth
          fieldName={"DentalSubscriberID"}
          getBenefitsData={getBenefitsData}
          handleDependentUpdate={handleDependentUpdate}
          allValues={values}
          selfData={{
            lastName: selfData?.LastName, middleName: selfData?.FirstName, SubscriberID: selfData?.EmployeeID,
            hrControl: selfData?.Dental_Hrcontrol,
          }}
          controlName={"dentalHrcontrol"}
          currentDependents={dependentInformation}
          planType="Dental"
        />
      )}
      <Container fluid={true}>
        <Row className="bg-primary rounded m-0 p-0 py-3 mb-3 ">
          <Typography variant="h5">
            <Icon style={{ fontSize: "25px", margin: "10px" }} name="graph" />
            Change Status
          </Typography>
        </Row>
        {
          !loding && (
            !values.dentalPlan ?
              <Alert severity="error" style={{ marginTop: "10px" }}>No Dental Plan Is Selected</Alert> : null
          )
        }
        {/* {loding ? <Card style={{ marginTop: "10px" }}>
          <div style={{ padding: "40px", textAlign: 'center', fontSize: "26px" }}>
            <div style={{ textAlign: "center", marginBottom: "50px" }}>
              <SadImg></SadImg>
            </div>
            Employee details not found!
          </div>
        </Card> : null} */}
        {true ? (
          <>
            <Card style={{ marginTop: "10px" }}>
              <Accordion
                className={classes.root}
                expanded={expanded.healthandDeduction}
                onChange={handleChangeExpanded("healthandDeduction")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className="sub-header w-100 p-1 bg-primary text-white"
                  style={{ width: "100%" }}
                >
                  <FontAwesomeIcon
                    icon={faRectangleList}
                    className="sub-header"
                    style={{
                      // color: "#1569C7",
                      marginRight: "10px",
                      marginTop: "3px",
                    }}
                  />
                  <div className="d-flex justify-content-between" style={{ width: "100%" }}  >
                    <div style={{ fontSize: "0.9375rem", fontWeight: "bold" }}>
                      Dental and Deduction Plan
                    </div>
                    <div style={{ marginRight: "20px" }}>
                      {/* <span style={{ fontSize: "1rem", fontWeight: "bold", margin: "0px 5px" }}> {getDateDifference()?.diffDays} Days</span>
                      Until Open Enrollment Ends on
                      <span style={{ fontSize: "1rem", fontWeight: "bold", margin: "0px 5px" }}> {moment(getDateDifference()?.defaultDate).format("MMM DD,YYYY")}</span> */}

                    </div>
                  </div>
                  {/* <Typography
                    className={classes.heading}
                    style={{ height: "auto" }}
                  >
                    Health and Deduction Plan
                  </Typography> */}
                </AccordionSummary>
                <AccordionDetails className="p-0 page-body-wrapper">
                  {values?.dentalCurrentProcessid ? (
                    <div style={{ margin: "5px 0" }}>
                      <StepperComponent
                        currStep={values?.dentalCurrentProcessid}
                        processStatus={processStatus}
                      />
                    </div>
                  ) : ""}
                  <StatusCard
                    auditTrail={auditTrailData}
                    processStatus={processStatus}
                  />
                  <ActiveHealthAndDeductionPlan
                    renderTextInput={renderTextInput}
                    renderCheckbox={renderCheckbox}
                    renderDropDown={renderDropDown}
                    renderDateInput={renderDateInput}
                    setValues={setValues}
                    values={values}
                    selfData={selfData}
                    handleUpdatePlan={handleUpdatePlan}
                    renderGroupCheckbox={renderGroupCheckbox}
                    isActiveUpdatePlan={
                      dependentInformation.length ? false : true
                    }
                    approvalHandler={approvalHandler}
                    currStep={values?.dentalCurrentProcessid}
                    processStatus={processStatus}
                  />
                </AccordionDetails>
              </Accordion>
            </Card>

            <Card style={{ marginTop: "10px" }}>
              <Accordion
                className={classes.root}
                expanded={expanded.dependent}
                onChange={handleChangeExpanded("dependent")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className="sub-header w-100 p-1 bg-primary text-white"
                  style={{ width: "100%" }}
                >
                  <FontAwesomeIcon
                    icon={faRectangleList}
                    className="sub-header"
                    style={{
                      // color: "#1569C7",
                      marginRight: "10px",
                      marginTop: "3px",
                    }}
                  />
                  <Typography
                    className={classes.heading}
                    style={{ height: "auto" }}
                  >
                    Dental Dependent Informations
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className="p-0 page-body-wrapper">
                  <DependentSelection
                    dependentInformation={dependentInformation}
                    setDependentInformation={setDependentInformation}
                    initialDependent={{
                      ...initialDependent,
                      subscriberId: values?.employee_no,
                      email: values?.email,
                      mailingAddress: values?.mailingAddress,
                      lastName: values?.last_name
                    }}
                    handleDependentUpdate={handleDependentUpdate}
                    handleDependentDelete={handleDependentDelete}
                    setClassValues={setClassValues}
                    values={values?.dentalDeductionClass}
                    handleOpen={handleOpen}
                    dentalPlan={values?.dentalPlan}
                  />
                </AccordionDetails>
              </Accordion>
            </Card>

          </>
        ) : null}
        {/* Approval Modal */}
        <ApprovalModal
          open={approvalHandleModal}
          onClose={handleClose}
          onSubmit={handleApprovalSubmit}
          plan={"Health"}
        />
        {auditTrailData.length > 0 ? <Card className="p-3 my-3" elevation={1}>
          <CardBody>
            <Col xs={12} lg={4} md={4} sm={12} className="d-flex align-items-center justify-content-between w-100">
              <Typography variant="h6">
                <FontAwesomeIcon
                  className="m-r-10 font-primary"
                  icon={faCircleInfo}
                  size="lg"
                />
                Audit Trail
              </Typography>
              <Btn
                attrBtn={{
                  color: "primary",
                  onClick: () => {
                    OpenHistoryComponent();
                  },
                  style: {
                    marginLeft: "6px",
                  },
                }}
              >
                History
              </Btn>
            </Col>

            {auditTrailData && auditTrailData && auditTrailData?.length > 0 && (
              <TableContainer style={{ marginBottom: "15px" }} component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="simple table">
                  {auditTrailData && auditTrailData && auditTrailData?.length > 0 && (
                    <TableHead>
                      <TableRow>
                        <TableCell>Sr No</TableCell>
                        <TableCell>Process</TableCell>
                        <TableCell>Performed by</TableCell>
                        <TableCell>Date Started</TableCell>
                        <TableCell>Date Completed</TableCell>
                        <TableCell>Status</TableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  {auditTrailData != null && auditTrailData && auditTrailData?.length > 0 ? (
                    <TableBody>
                      {auditTrailData.map((item, i) => (
                        <TableRow key={item.id}>
                          <TableCell>{i + 1}</TableCell>
                          <TableCell>{item?.StatusName || "N/A"}</TableCell>
                          <TableCell>{item?.peformedByName || "N/A"}</TableCell>
                          <TableCell>
                            {item.dateStarted
                              ? dayjs(item?.dateStarted).format("MM/DD/YYYY")
                              : "N/A"}
                          </TableCell>
                          <TableCell>
                            {item.dateCompleted
                              ? dayjs(item.dateCompleted).format("MM/DD/YYYY")
                              : "N/A"}
                          </TableCell>
                          <TableCell>{item.Status || "Completed"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={6} className="text-center p-2">
                          No Data Found
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            )}
          </CardBody>
        </Card> : null}
        <DifferencesModal
          visible={openDiffModal}
          setVisible={setOpenDiffModal}
          data={differenceData.length > 0 ? differenceData : []}
          loadingPanel={loadingPanel}
          loading={differenceData && differenceData.length > 0 ? false : true}
        />
        <HistoryDataTable
          openHistory={isHistoryModalOpen}
          setOpenHistory={setIsHistoryModalOpen}
          data={historyData}
          sortData={sortData}
          selectedColumns={HistoryColumns}
          setSortedColumns={setSortedColumns}
          onSortChange={handleSortChange}
          actions={actions}
          title={"History"}
        />
      </Container>
    </Fragment>
  );
};

export default DentalEnrollmentMain;
